import { Option } from "../components/tailwind/Dropdown";
import { DealThreadMessageCreatedData } from "../contexts/websockets";
import { DealRole, DealThreadMessage, FileType } from "../graphql/generated";

export function dealRoleToDealRoleOption(
  dealRole: Pick<DealRole, "id" | "name" | "description">,
): Option {
  return {
    value: dealRole.id,
    label: dealRole.name,
    description: dealRole.description,
  };
}

export function gqlDealThreadMessageToWebsocketDealThreadMessage(
  message: DealThreadMessage,
  dealThreadId: string,
): DealThreadMessageCreatedData {
  return {
    dealThreadID: dealThreadId,
    dealThreadMessageID: message.id,
    dealThreadMessage: {
      role: message.role,
      status: message.status,
      id: message.id,
      sources: {
        sources: message.sources ?? [],
      },
      content: {
        type: "text",
        text: {
          value: message.content.text.value,
        },
        blocks: message.content.blocks.map((block) => ({
          type: block.type,
          durationMs: block.durationMs ?? undefined,
          text: block.text ?? undefined,
          reasoning: block.reasoning ?? undefined,
          toolName: block.toolName ?? undefined,
          toolArgs: block.toolArgs ?? undefined,
          toolCallId: block.toolCallId ?? undefined,
          toolResult: block.toolResult ?? undefined,
        })),
        quotes: message.content.quotes.map((quote) => ({
          quote: quote.quote,
          fileId: quote.file?.id ?? "",
          dataRoomFileId: quote.file?.id ?? "",
          dataRoomFileVersionId: quote.file?.id ?? "",
          dataRoomFileName: quote.file?.name ?? "",
          dataRoomFileType: quote.file?.fileType ?? FileType.Other,
          questionId: quote.question?.id ?? "",
          dataRoomFolderId: quote.file ? quote.file.folderId : "",
          status: quote.status,
          rectsOnPage: quote.rectsOnPage ?? undefined,
          pageIndex: quote.pageIndex ?? undefined,
          excel: quote.excel ?? undefined,
        })),
        files: message.content.files.map((f) => ({
          dataRoomFileId: f.file.id,
          dataRoomFileName: f.file.name,
          dataRoomFileType: f.file.fileType,
          dataRoomFileVersionId: f.file.id,
          pageIndex: f.pageIndex ?? undefined,
          rectsOnPage: f.rectsOnPage ?? undefined,
        })),
      },
      createdAt: message.createdAt,
    },
  };
}
